import React, { useState } from 'react';
import { bool, shape, string } from 'prop-types';

import Button from '@material-ui/core/Button';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';

import defaultClasses from './WeatherDataContextMenu.module.css';

const WeatherDataContextMenu = ({ error, hidden, onToggleWeatherDataModal }) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);

    if (hidden) {
        return null;
    }

    function handleClose() {
        setAnchorEl(null);
    }

    function handleOpen(event) {
        setAnchorEl(event.currentTarget);
    }

    function handleViewWeatherData() {
        onToggleWeatherDataModal(true);
        handleClose();
    }

    return (
        <>
            <Button
                aria-owns={open && 'render-props-menu'}
                aria-haspopup="true"
                onClick={handleOpen}
                className={defaultClasses.toggleButton}
            >
                <i className="fas fa-ellipsis-h" />
            </Button>
            <Menu
                id="render-props-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                className={defaultClasses.menu}
            >
                <MenuItem
                    classes={{
                        root: defaultClasses.menuItem
                    }}
                    onClick={handleViewWeatherData}
                >
                    <img
                        alt=""
                        className={defaultClasses.menuItemIcon}
                        src="/assets/images/weatherDataIconColor.svg"
                    />
                    Preview Data
                </MenuItem>
            </Menu>
        </>
    );
};

WeatherDataContextMenu.defaultProps = {
    hidden: false
};

WeatherDataContextMenu.propTypes = {
    hidden: bool,
    rule:   shape({
        id: string
    })
};

export default WeatherDataContextMenu;
